export default {
    UPDATED: 'ORDERGROUP.UPDATE'
};
